export default __webpack_public_path__ + "static/media/29_desktop.1b436e49.jpg";